(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dual-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-morning-clips]').forEach((video) => {
    const clips = [[0, 4], [16, 20]];
    let index = 0;
    const next = () => {
      index = (index + 1) % clips.length;
      video.currentTime = clips[index][0];
      video.play().catch(() => {});
    };
    video.addEventListener('timeupdate', () => {
      if (video.currentTime >= clips[index][1]) next();
    });
    video.addEventListener('ended', next);
    video.addEventListener('loadedmetadata', () => {
      video.currentTime = clips[index][0];
    }, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
function initFaqMotion(root = document) {
  root.querySelectorAll('.a-section--faq details').forEach((details) => {
    const summary = details.querySelector('summary');
    const body = details.querySelector('.a-accordion__body');
    if (!summary || !body || details.dataset.motionReady) return;
    details.dataset.motionReady = 'true';
    let animation;
    let targetOpen = details.open;
    summary.addEventListener('click', (event) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      event.preventDefault();
      const start = details.getBoundingClientRect().height;
      if (animation) animation.cancel();
      targetOpen = !targetOpen;
      details.open = true;
      details.style.overflow = 'hidden';
      const border = parseFloat(getComputedStyle(details).borderBottomWidth) || 0;
      const end = summary.getBoundingClientRect().height + (targetOpen ? body.getBoundingClientRect().height : 0) + border;
      animation = details.animate({ height: [start + 'px', end + 'px'] }, { duration: 240, easing: 'cubic-bezier(.22,.61,.36,1)' });
      animation.onfinish = () => {
        details.open = targetOpen;
        details.style.overflow = '';
        animation = null;
      };
    });
    details.addEventListener('toggle', () => { if (!animation) targetOpen = details.open; });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initFaqMotion());
else initFaqMotion();
document.addEventListener('shopify:section:load', (event) => initFaqMotion(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  function initHeroVideo(root) {
    root.querySelectorAll('.a-hero__video').forEach(video => {
    if (video.dataset.initialized) return;
    video.dataset.initialized = 'true';
    if (video.dataset.desktopPoster) {
      const desktop = window.matchMedia('(min-width: 750px)');
      const mobilePoster = video.poster;
      const updatePoster = () => {
        video.poster = desktop.matches ? video.dataset.desktopPoster : mobilePoster;
      };
      updatePoster();
      desktop.addEventListener('change', () => {
        if (!video.isConnected) return;
        updatePoster();
        video.load();
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.play().catch(() => {});
        }
      });
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.autoplay = false;
      video.pause();
    }
    });
  }
  initHeroVideo(document);
  document.addEventListener('shopify:section:load', event => initHeroVideo(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-benefits"] && !Shopify.designMode) return;
  try {
    
function initProcessVideo(root = document) {
  root.querySelectorAll('.a-pbenefits__visual--video').forEach((figure) => {
    const video = figure.querySelector('video');
    const sound = figure.querySelector('[data-process-video-sound]');
    const expand = figure.querySelector('[data-process-video-expand]');
    if (!video || !sound || !expand || sound.dataset.ready) return;
    sound.dataset.ready = 'true';
    video.muted = true;
    video.controls = false;
    sound.addEventListener('click', () => {
      video.muted = !video.muted;
      sound.setAttribute('aria-pressed', String(!video.muted));
      sound.setAttribute('aria-label', video.muted ? sound.dataset.mutedLabel : sound.dataset.soundLabel);
      sound.querySelector('[data-sound-off]').style.display = video.muted ? '' : 'none';
      sound.querySelector('[data-sound-on]').style.display = video.muted ? 'none' : '';
      video.play().catch(() => {});
    });
    expand.addEventListener('click', () => {
      if (document.fullscreenElement) document.exitFullscreen().catch(() => {});
      else if (figure.requestFullscreen) figure.requestFullscreen().catch(() => { if (video.webkitEnterFullscreen) video.webkitEnterFullscreen(); });
      else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
    });
    video.play().catch(() => {});
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initProcessVideo());
else initProcessVideo();
document.addEventListener('shopify:section:load', (event) => initProcessVideo(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-card-carousel')) {
    customElements.define('product-card-carousel', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const controls = this.nextElementSibling;
        const previous = controls.querySelector('[data-carousel-previous]');
        const next = controls.querySelector('[data-carousel-next]');
        const updateControls = () => {
          const max = this.scrollWidth - this.clientWidth;
          controls.hidden = max <= 2;
          previous.disabled = this.scrollLeft <= 2;
          next.disabled = this.scrollLeft >= max - 2;
        };
        const move = direction => {
          const card = this.querySelector('.a-card');
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this).gap);
          this.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        this.addEventListener('scroll', updateControls, { ...options, passive: true });
        this.resizeObserver = new ResizeObserver(updateControls);
        this.resizeObserver.observe(this);
        updateControls();
        let startX = 0;
      let startScroll = 0;
      let velocity = 0;
      let lastMoveTime = 0;
      let lastX = 0;
      let activePointer = null;
      let dragged = false;
      let inertiaFrame = 0;
      this.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        cancelAnimationFrame(inertiaFrame);
        this.classList.remove('is-dragging');
        activePointer = event.pointerId;
        startX = lastX = event.clientX;
        startScroll = this.scrollLeft;
        lastMoveTime = performance.now();
        velocity = 0;
        dragged = false;
      }, options);
      this.addEventListener('pointermove', event => {
        if (event.pointerId !== activePointer) return;
        const distance = event.clientX - startX;
        if (!dragged && Math.abs(distance) < 4) return;
        if (!dragged) { dragged = true; this.setPointerCapture(activePointer); this.classList.add('is-dragging'); }
        event.preventDefault();
        const now = performance.now();
        velocity = velocity * 0.25 + Math.max(-3, Math.min(3, (lastX - event.clientX) / Math.max(1, now - lastMoveTime))) * 0.75;
        lastX = event.clientX;
        lastMoveTime = now;
        this.scrollTo({left: startScroll - distance, behavior: 'instant'});
      }, options);
      const finish = () => {
        if (activePointer === null) return;
        activePointer = null;
        const stop = () => { velocity = 0; this.classList.remove('is-dragging'); };
        if (!dragged || performance.now() - lastMoveTime > 100 || matchMedia('(prefers-reduced-motion: reduce)').matches) { stop(); return; }
        let frameTime = performance.now();
        const glide = now => {
          const dt = Math.min(32, now - frameTime);
          frameTime = now;
          const before = this.scrollLeft;
          this.scrollTo({left: before + velocity * dt, behavior: 'instant'});
          velocity *= Math.exp(-dt / 220);
          if (Math.abs(velocity) < 0.02 || Math.abs(this.scrollLeft - before) < 0.1) { stop(); return; }
          inertiaFrame = requestAnimationFrame(glide);
        };
        inertiaFrame = requestAnimationFrame(glide);
      };
      this.addEventListener('pointerup', finish, options);
        this.addEventListener('pointercancel', finish, options);
        this.addEventListener('lostpointercapture', finish, options);
        this.addEventListener('pointerleave', () => {
          if (!dragged) activePointer = null;
        }, options);
        this.addEventListener('dragstart', event => event.preventDefault(), options);
        this.addEventListener('click', event => {
          if (!dragged) return;
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }, { ...options, capture: true });
        this.addEventListener('keydown', event => {
          if (event.target !== this || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
      }
      disconnectedCallback() { this.events?.abort(); this.resizeObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ingredient-carousel')) {
    customElements.define('ingredient-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.a-ping__grid');
        this.classList.toggle('has-more', this.track.children.length > 5);
        this.controls = this.querySelector('.a-ping__controls');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.direction = 1;
        this.visible = false;
        this.stopped = false;
        this.abort = new AbortController();
        const on = (target, event, handler) => target.addEventListener(event, handler, { signal: this.abort.signal });
        on(this.previous, 'click', () => { this.stop(); this.move(-1); });
        on(this.next, 'click', () => { this.stop(); this.move(1); });
        on(this, 'pointerenter', () => { this.hovering = true; this.schedule(); });
        on(this, 'pointerleave', () => { this.hovering = false; this.schedule(); });
        on(this, 'focusin', () => this.stop());
        let startX = 0;
      let startScroll = 0;
      let velocity = 0;
      let lastMoveTime = 0;
      let lastX = 0;
      let pointer = null;
      let dragged = false;
      let inertiaFrame = 0;
      on(this.track, 'pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.stop(); this.cancelAnimation(); cancelAnimationFrame(inertiaFrame);
        this.track.classList.remove('is-dragging');
        pointer = event.pointerId;
        startX = lastX = event.clientX;
        startScroll = this.track.scrollLeft;
        lastMoveTime = performance.now();
        velocity = 0;
        dragged = false;
      });
      on(this.track, 'pointermove', event => {
        if (event.pointerId !== pointer) return;
        const distance = event.clientX - startX;
        if (!dragged && Math.abs(distance) < 4) return;
        if (!dragged) { dragged = true; this.track.setPointerCapture(pointer); this.track.classList.add('is-dragging'); }
        event.preventDefault();
        const now = performance.now();
        velocity = velocity * 0.25 + Math.max(-3, Math.min(3, (lastX - event.clientX) / Math.max(1, now - lastMoveTime))) * 0.75;
        lastX = event.clientX;
        lastMoveTime = now;
        this.track.scrollTo({left: startScroll - distance, behavior: 'instant'});
      });
      const finish = () => {
        if (pointer === null) return;
        pointer = null;
        const stop = () => { velocity = 0; this.track.classList.remove('is-dragging'); };
        if (!dragged || performance.now() - lastMoveTime > 100 || matchMedia('(prefers-reduced-motion: reduce)').matches) { stop(); return; }
        let frameTime = performance.now();
        const glide = now => {
          const dt = Math.min(32, now - frameTime);
          frameTime = now;
          const before = this.track.scrollLeft;
          this.track.scrollTo({left: before + velocity * dt, behavior: 'instant'});
          velocity *= Math.exp(-dt / 220);
          if (Math.abs(velocity) < 0.02 || Math.abs(this.track.scrollLeft - before) < 0.1) { stop(); return; }
          inertiaFrame = requestAnimationFrame(glide);
        };
        inertiaFrame = requestAnimationFrame(glide);
      };
      on(this.track, 'pointerup', finish);
        on(this.track, 'pointercancel', finish);
        on(this.track, 'lostpointercapture', finish);
        on(this.track, 'pointerleave', () => { if (!dragged) pointer = null; });
        on(this.track, 'dragstart', event => event.preventDefault());
        on(this.track, 'wheel', () => { this.stop(); this.cancelAnimation(); });
        on(this.track, 'keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.stop();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        });
        on(this.track, 'scroll', () => this.update());
        on(document, 'visibilitychange', () => this.schedule());
        on(this.motion, 'change', () => { this.cancelAnimation(); this.schedule(); });
        this.resize = new ResizeObserver(() => { this.cancelAnimation(); this.update(); this.schedule(); });
        this.resize.observe(this.track);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0.25 });
        this.observer.observe(this);
        this.update();
      }
      stop() {
        this.stopped = true;
        clearTimeout(this.timer);
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max <= 2;
        this.previous.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.stopped || this.hovering || !this.visible || document.hidden || this.motion.matches || this.controls.hidden || (this.previous.disabled && this.next.disabled)) return;
        this.timer = setTimeout(() => {
          if (this.next.disabled) this.direction = -1;
          if (this.previous.disabled) this.direction = 1;
          this.move(this.direction);
          this.schedule();
        }, 6000);
      }
      cancelAnimation() {
        cancelAnimationFrame(this.frame);
        this.track.style.removeProperty('scroll-snap-type');
      }
      move(direction) {
        this.cancelAnimation();
        const card = this.track.querySelector('.a-ping__card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        const start = this.track.scrollLeft;
        const target = Math.max(0, Math.min(this.track.scrollWidth - this.track.clientWidth, (Math.round(start / step) + direction) * step));
        if (this.motion.matches) { this.track.scrollLeft = target; this.update(); return; }
        this.track.style.scrollSnapType = 'none';
        const began = performance.now();
        const animate = now => {
          const progress = Math.min((now - began) / 1000, 1);
          const eased = (1 - Math.cos(Math.PI * progress)) / 2;
          this.track.scrollLeft = start + (target - start) * eased;
          if (progress < 1) this.frame = requestAnimationFrame(animate);
          else { this.track.style.removeProperty('scroll-snap-type'); this.update(); }
        };
        this.frame = requestAnimationFrame(animate);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.cancelAnimation();
        this.abort.abort();
        this.resize.disconnect();
        this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rating-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customer-review-carousel')) {
    customElements.define('customer-review-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.viewport = this.querySelector('.a-customer-reviews__viewport');
        this.track = this.querySelector('.a-customer-reviews__track');
        this.originals = Array.from(this.querySelectorAll('[data-review-slide]'));
        if (this.originals.length < 2) return;
        this.index = this.originals.length;
        this.userPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.visible = false;
        this.hovering = false;
        this.focused = false;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const clone = card => { const node = card.cloneNode(true); node.setAttribute('aria-hidden', 'true'); node.removeAttribute('data-shopify-editor-block'); return node; };
        this.track.prepend(...this.originals.map(clone));
        this.track.append(...this.originals.map(clone));
        this.slides = Array.from(this.track.children);
        this.center(false);
        this.dots = Array.from(this.querySelectorAll('[data-review-dot]'));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => { clearTimeout(this.timer); this.index = this.originals.length + index; this.center(true); this.paintDots(); }, {signal}));
        this.viewport.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1, true); } }, {signal});
        this.viewport.addEventListener('pointerdown', event => {
          clearTimeout(this.timer); clearTimeout(this.settle); this.stopMotion();
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.drag = { id: event.pointerId, x: event.clientX, left: this.viewport.scrollLeft };
          this.viewport.classList.add('is-dragging');
          this.viewport.setPointerCapture(event.pointerId);
          event.preventDefault();
        }, {signal});
        this.viewport.addEventListener('pointermove', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          this.viewport.scrollLeft = this.drag.left - (event.clientX - this.drag.x);
        }, {signal});
        const release = event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const id = this.drag.id;
          this.drag = null;
          this.updateCenter();
          this.center(true);
          this.viewport.classList.remove('is-dragging');
          if (this.viewport.hasPointerCapture(id)) this.viewport.releasePointerCapture(id);
        };
        this.viewport.addEventListener('pointerup', release, {signal});
        this.viewport.addEventListener('pointercancel', release, {signal});
        this.viewport.addEventListener('lostpointercapture', release, {signal});
        this.viewport.addEventListener('dragstart', event => event.preventDefault(), {signal});
        this.viewport.addEventListener('wheel', () => { this.stopMotion(); clearTimeout(this.timer); }, {signal, passive: true});
        this.viewport.addEventListener('scroll', () => { clearTimeout(this.settle); if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = 0; this.updateCenter(); this.paintDots(); }); if (!this.drag && !this.animating) this.settle = setTimeout(() => this.settled(), 140); }, {signal, passive: true});
        this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, {signal});
        this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, {signal});
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
        this.addEventListener('focusout', () => { queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); }); }, {signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        this.resize = new ResizeObserver(() => this.center(false));
        this.resize.observe(this.viewport);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, {threshold: 0.25});
        this.observer.observe(this);
        this.paintDots();
      }
      paintDots() { const active = this.index % this.originals.length; this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active))); this.slides.forEach((card, index) => { const distance = Math.abs(index - this.index); card.classList.toggle('is-center', distance === 0); card.classList.toggle('is-neighbor', distance === 1); }); }
      stopMotion() {
        cancelAnimationFrame(this.motionFrame);
        this.animating = false;
        this.viewport.classList.remove('is-animating');
      }
      center(smooth) {
        const card = this.slides[this.index];
        if (!card) return;
        clearTimeout(this.settle);
        this.stopMotion();
        const targetIndex = this.index;
        const target = card.offsetLeft - this.track.offsetLeft + card.offsetWidth / 2 - this.viewport.clientWidth / 2;
        const start = this.viewport.scrollLeft;
        if (!smooth || matchMedia('(prefers-reduced-motion: reduce)').matches || Math.abs(target - start) < 1) {
          this.viewport.scrollTo({left: target, behavior: 'instant'});
          return;
        }
        this.animating = true;
        this.viewport.classList.add('is-animating');
        const duration = 600;
        const started = performance.now();
        const frame = now => {
          const progress = Math.min(1, (now - started) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.viewport.scrollLeft = start + (target - start) * eased;
          if (progress < 1) this.motionFrame = requestAnimationFrame(frame);
          else {
            this.index = targetIndex;
            this.stopMotion();
            this.settled();
          }
        };
        this.motionFrame = requestAnimationFrame(frame);
      }
      move(direction, manual) { clearTimeout(this.timer); this.index += direction; this.center(true); this.paintDots(); if (manual) this.querySelector('[data-review-status]').textContent = ((this.index % this.originals.length) + 1) + ' / ' + this.originals.length; }
      updateCenter() {
        const center = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
        let distance = Infinity;
        this.slides.forEach((card, index) => { const d = Math.abs(card.offsetLeft - this.track.offsetLeft + card.offsetWidth / 2 - center); if (d < distance) { distance = d; this.index = index; } });
      }
      settled() {
        if (this.drag || this.animating) return;
        this.updateCenter();
        if (this.index < this.originals.length) { this.index += this.originals.length; this.center(false); }
        else if (this.index >= this.originals.length * 2) { this.index -= this.originals.length; this.center(false); }
        this.paintDots(); this.schedule();
      }
      schedule() { clearTimeout(this.timer); if (!this.drag && !this.animating && !this.userPaused && this.visible && !this.hovering && !this.focused && !document.hidden) this.timer = setTimeout(() => this.move(1, false), Math.min(Number(this.dataset.interval) || 4000, 4000)); }
      disconnectedCallback() { this.stopMotion(); clearTimeout(this.timer); clearTimeout(this.settle); cancelAnimationFrame(this.scrollFrame); this.abort?.abort(); this.resize?.disconnect(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
